export const ROAD_SIMPLE_WHITE = '#ffffff'
export const BLACK = '#000000'
export const WATER_CYAN = '#75cff0'
export const BUILDINGS = '#dad7d3'
export const GREENSPACE = '#b4e49b'
export const BASE_BACKGROUND = '#e6e4e0'
